/**
 * Created by Ning Jiang on 2022-10-14.
 */
import {SerialSymbol} from "./SerialSymbol";
import {SerialSymbolState} from "./SerialSymbolConfig";
import {ReelPositionController} from "../reels/ReelPositionController";

export class MaskedSymbol extends SerialSymbol {

    protected _heightMask:PIXI.Graphics;

    constructor(symbolName:string, reelId:number, symbolHeight:number, initState:SerialSymbolState) {
        super(symbolName, reelId, symbolHeight, initState);
    }

    protected getTextureHeight():string {
        return ``;
    }

    protected updateSymbolHeight() {
        if(!this.transform) {
            return;
        }

        super.updateSymbolHeight();

        if(this._currentState === SerialSymbolState.SPIN) {
            if(this._heightMask) {
                this._animation.mask = null;
                this._heightMask.visible = false;
            }
            return;
        }

        if(this._symbolHeight === ReelPositionController.DEFAULT_SYMBOL_HEIGHT) {
            if(this._heightMask) {
                this._animation.mask = null;
                this._heightMask.visible = false;
            }
            this._animation.position.y = this._centerPosition.y;
            return;
        }

        if(this._heightMask) {
            this._heightMask.visible = true;
            this._animation.mask = this._heightMask;
            this._heightMask.height = this._symbolHeight;
            return;
        }

        this.createMask();
    }

    protected createMask():void {
        if(!this._heightMask && this._symbolHeight != ReelPositionController.DEFAULT_SYMBOL_HEIGHT) {
            this._heightMask = new PIXI.Graphics();
            this._heightMask.beginFill(0xFF0000, 1);
            this._heightMask.drawRect(-ReelPositionController.DEFAULT_SYMBOL_WIDTH * 0.5, -this._symbolHeight * 0.5, ReelPositionController.DEFAULT_SYMBOL_WIDTH, this._symbolHeight);
            this._heightMask.position.set(this._centerPosition.x, this._centerPosition.y);
            this.addChild(this._heightMask);
            this._animation.mask = this._heightMask;
        }
    }

    public getStateAnimation(state:SerialSymbolState, inVars:gsap.TweenVars, outVars:gsap.TweenVars, frames?:number[]):TimelineLite {
        const tl = super.getStateAnimation(state, inVars, outVars, frames);
        tl.add(() => {
            this.updateSymbolHeight();
        }, 0);
        return tl;
    }

    protected createState(state:SerialSymbolState) {
        if(state !== SerialSymbolState.SPIN) {
            this.createMask();
        }

        super.createState(state);
    }

    protected getAssetsPositionY():number {
        if(!SerialSymbol.SYMBOL_DISPLAY_CENTER_Y[this.symbolName]) {
            return 0;
        }

        const defaultCenter = SerialSymbol.SYMBOL_DISPLAY_CENTER_Y[this.symbolName];
        const top = Math.min(Math.max(this._symbolHeight * 0.5, defaultCenter), ReelPositionController.DEFAULT_SYMBOL_HEIGHT - this._symbolHeight * 0.5);
        return this._centerPosition.y + ReelPositionController.DEFAULT_SYMBOL_HEIGHT * 0.5 - top;
    }
}